export const taskSortOptions = [
    {
        "label": "Имя",
        "value": "name"
    },
    {
        "label": "Приоритет",
        "value": "priority"
    },
    {
        "label": "Дата создания",
        "value": "createdAt"
    },
    {
        "label": "Дата обновления",
        "value": "updatedAt"
    }
]

export const directionOptions = [
    {
        "label": "Возрастание",
        "value": "ASC"
    },
    {
        "label": "Убывание",
        "value": "DESC"
    }
]